import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'loading-error',
  templateUrl: './loading-error.component.html',
  styles: [''],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingErrorComponent {
  @Input() message = '';
  @Input() innerDivClassName = 'mb-3 mt-3';
  loadingString = '';
}
